<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="font-family:Calisto MT">Dedication</h1>
<p class="p" style="text-align: center;">I’d like to dedicate this book to my parents who have helped me since day one. Liz Pichon is a big one. She’s 70% of the reason why I started this book. In fact, I have a whole collection of her books. She inspired me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?56c08564